import PropTypes from 'prop-types';
import Icons from './icons';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Icon({
  name
}) {
  const Component = Icons[name];
  return /*#__PURE__*/_jsx(Component, {});
}
Icon.propTypes = {
  name: PropTypes.string.isRequired
};